import { useCallback, useEffect, useState } from 'react';
import { decodeJwt } from 'jose';
const ONE_MINUTE_IN_MILLISECONDS = 60 * 1000;
export default function useConnectionDetails(appConfig, userMetadata, restaurantHash) {
    // Generate room connection details, including:
    //   - A random Room name
    //   - A random Participant name
    //   - An Access Token to permit the participant to join the room
    //   - The URL of the LiveKit server to connect to
    //
    // In real-world application, you would likely allow the user to specify their
    // own participant name, and possibly to choose from existing rooms to join.
    const [connectionDetails, setConnectionDetails] = useState(null);
    const fetchConnectionDetails = useCallback(async () => {
        var _a, _b;
        // No hacer fetch si no hay userMetadata aún
        if (!userMetadata) {
            return null;
        }
        setConnectionDetails(null);
        const url = new URL((_a = process.env.NEXT_PUBLIC_CONN_DETAILS_ENDPOINT) !== null && _a !== void 0 ? _a : 'https://chatweb.xan-ia.es/api/connection-details', window.location.origin);
        console.log('ENV' + process.env.NEXT_PUBLIC_CONN_DETAILS_ENDPOINT, url);
        let data;
        try {
            const requestBody = {
                room_config: appConfig.agentName
                    ? {
                        agents: [{ agent_name: appConfig.agentName }],
                    }
                    : undefined,
                user_metadata: Object.assign(Object.assign({}, userMetadata), { hash: restaurantHash }),
            };
            console.log('Debug - Enviando al API:', JSON.stringify(requestBody, null, 2));
            const res = await fetch(url.toString(), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Sandbox-Id': (_b = appConfig.sandboxId) !== null && _b !== void 0 ? _b : '',
                },
                body: JSON.stringify(requestBody),
            });
            data = await res.json();
        }
        catch (error) {
            console.error('Error fetching connection details:', error);
            throw new Error('Error fetching connection details!');
        }
        setConnectionDetails(data);
        return data;
    }, [userMetadata, restaurantHash, appConfig.sandboxId, appConfig.agentName]);
    useEffect(() => {
        // Solo hacer fetch si hay userMetadata
        if (userMetadata) {
            fetchConnectionDetails();
        }
    }, [fetchConnectionDetails, userMetadata]);
    const isConnectionDetailsExpired = useCallback(() => {
        const token = connectionDetails === null || connectionDetails === void 0 ? void 0 : connectionDetails.participantToken;
        if (!token) {
            return true;
        }
        const jwtPayload = decodeJwt(token);
        if (!jwtPayload.exp) {
            return true;
        }
        const expiresAt = new Date(jwtPayload.exp - ONE_MINUTE_IN_MILLISECONDS);
        const now = new Date();
        return expiresAt >= now;
    }, [connectionDetails === null || connectionDetails === void 0 ? void 0 : connectionDetails.participantToken]);
    const existingOrRefreshConnectionDetails = useCallback(async () => {
        if (isConnectionDetailsExpired() || !connectionDetails) {
            return fetchConnectionDetails();
        }
        else {
            return connectionDetails;
        }
    }, [connectionDetails, fetchConnectionDetails, isConnectionDetailsExpired]);
    return {
        connectionDetails,
        refreshConnectionDetails: fetchConnectionDetails,
        existingOrRefreshConnectionDetails,
    };
}
